<template>
  <content-dialog
    v-if="checklist"
    :visible.sync="modalVisible"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :small-title="$vuetify.breakpoint.xsOnly"
    :persistent="$store.state.ui.alert.active"
    max-width="900px"
  >
    <!--<editor-fold desc="Dialog Title">-->
    <template slot="dialogTitle">
      View Checklist
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Content">-->
    <v-card-text :class="{'pa-4': $vuetify.breakpoint.smAndUp }">
      <checklist-view :checklist="checklist" />
    </v-card-text>
    <!--</editor-fold>-->

    <template v-slot:dialogActions="{}">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Close
      </v-btn>
      <v-btn
        v-if="checklist"
        color="primary"
        :to="`checklists/${checklist.id}/print`"
        target="_blank"
      >
        <v-icon left>
          print
        </v-icon>
        Print Checklist
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
  import ContentDialog from '@/components/helpers/Dialog'
  import ChecklistView from '@/components/service/checklists/ChecklistView'

  export default {
    name: 'ChecklistViewDialog',
    components: {
      ContentDialog,
      ChecklistView
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      checklist: {
        type: Object,
        default: null
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    }
  }
</script>
